module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Storm-eb6033903df64df7b8a210c6ced3c89b.svg";